import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component({
  components: {
  }
})
export default class CircleProgress extends Vue {
  @Prop({ default: 10 }) roundRadius!: any
  @Prop({ default: 50 }) roundPercent!: any
  @Prop({ default: 5 }) strokeWidth!: any
  @Prop({ default: 'red' }) stroke!: any
  @Prop({ default: '' }) styleInject!: String

  strokeDasharray = ''
  widthHeight = 0

  mounted () {
    this.widthHeight = (this.roundRadius * 2) + parseInt(this.strokeWidth)

    let roundCircum = 2 * this.roundRadius * Math.PI
    let roundDraw = this.roundPercent * roundCircum / 100
    this.strokeDasharray = `stroke-dasharray: ${roundDraw}, 999px`
  }
}
